import React from "react";
import Nicholas from "assets/Nicholas.png";

// form & validsation
import * as yup from "yup";
import { FormLabel, FormInput, FormRadio } from "components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { customClasses } from "styles";

// schema
const schema = yup.object().shape({
  children: yup
    .object()
    .shape({
      if_children_together: yup.string().required("You must provide a value"),
      if_children_partner_another: yup
        .string()
        .required("You must provide a value"),
      if_children_user_another: yup
        .string()
        .required("You must provide a value"),
    })
    .required(),
});
export function Step06({ onSubmit, store }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: store,
    resolver: yupResolver(schema),
  });
  const handleData = (values) => {
    const copy_data = Object.assign({}, store.children);
    const merger_current_values = { ...copy_data, ...values.children };
    const mergeToStore = { ...store, children: merger_current_values };
    onSubmit(mergeToStore);
  };

  return (
    <form id="divorce-form" onSubmit={handleSubmit(handleData)}>
      <section>
        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="children.if_children_together"
            className={customClasses.questionText}
            error={errors?.children?.if_children_together?.message}
          >
            Do you and{" "}
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}{" "}
            have any children together?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="children.if_children_together"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="children.if_children_together"
              register={register}
            />
          </article>
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="children.if_children_partner_another"
            className={customClasses.questionText}
            error={errors?.children?.if_children_partner_another?.message}
          >
            Does{" "}
            {store?.user_details?.partner_first_name
              ? store?.user_details?.partner_first_name
              : "Your Ex-Partner"}{" "}
            have children from another relationship?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="children.if_children_partner_another"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="children.if_children_partner_another"
              register={register}
            />
          </article>
        </section>

        <section className="pb-6 md:pb-5">
          <FormLabel
            htmlFor="children.if_children_user_another"
            className={customClasses.questionText}
            error={errors?.children?.if_children_user_another?.message}
          >
            Do you have children from another relationship?
          </FormLabel>
          <article>
            <FormRadio
              setValue={setValue}
              value="Yes"
              name="children.if_children_user_another"
              register={register}
            />
            <FormRadio
              setValue={setValue}
              value="No"
              name="children.if_children_user_another"
              register={register}
            />
          </article>
        </section>
      </section>
    </form>
  );
}
